import React from "react";
import { Link } from "react-router-dom";
import styles from "../styles/ToolsPage.module.css";

export default function ToolsPage() {
  return (
    <div className={styles.page}>
      <div className={styles.top}>
        <div>
          <div className={styles.title}>Tools</div>
          <div className={styles.subtitle}>Internal tools for Grow Up AM.</div>
        </div>
      </div>

      <div className={styles.grid}>
        {/* ✅ QR Tool */}
        <Link to="/tools/qr" className={styles.card}>
          <div className={styles.cardTop}>
            <div className={styles.icon}>QR</div>
            <div className={styles.cardTitle}>QR Code Manager</div>
          </div>
          <div className={styles.cardDesc}>
            Create, customize, add logo, download & manage QR codes.
          </div>
          <div className={styles.cardFooter}>
            <span className={styles.open}>Open</span>
          </div>
        </Link>

        {/* ✅ NEW: Image Tools */}
        <Link to="/tools/image-tools" className={styles.card}>
          <div className={styles.cardTop}>
            <div className={styles.icon}>IMG</div>
            <div className={styles.cardTitle}>Image Tools</div>
          </div>
          <div className={styles.cardDesc}>
            Convert images (PNG/JPG/WEBP) + generate PDF from images.
          </div>
          <div className={styles.cardFooter}>
            <span className={styles.open}>Open</span>
          </div>
        </Link>

        {/* Placeholder */}
        <div className={`${styles.card} ${styles.disabled}`}>
          <div className={styles.cardTop}>
            <div className={styles.icon}>+</div>
            <div className={styles.cardTitle}>More tools</div>
          </div>
          <div className={styles.cardDesc}>Coming soon…</div>
          <div className={styles.cardFooter}>
            <span className={styles.soon}>Soon</span>
          </div>
        </div>
      </div>
    </div>
  );
}
